/* eslint-disable import/no-unassigned-import */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';

import { DialogRef, DialogService } from '@ngneat/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import {
  FacebookLoginProvider,
  GoogleLoginProvider,
  SocialAuthService,
  SocialUser,
} from 'angularx-social-login';
import firebase from 'firebase/app';
import {
  Agency,
  AuthenticatedApiService,
  AuthenticationService,
  User,
  Vehicle,
} from 'rest-client';
import { from, Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { ActiveCampaignService } from '@app/modules/core/services/active-campaign/active-campaign.service';
import { UserService } from '@app/modules/core/services/user/user.service';
import {
  StartLoadingAction,
  StopLoadingAction,
} from '@app/modules/core/states/app-state/app.actions';
import {
  SetAgencyAction,
  SetUserAction,
} from '@app/modules/core/states/auth-state/auth.actions';
import {
  RemoveVehicleAction,
  SetVehicleAction,
} from '@app/modules/core/states/vehicle-state/vehicle.actions';
import { VehicleState } from '@app/modules/core/states/vehicle-state/vehicle.state';
import {
  PROVIDERS,
  SOCIAL_TOKENS,
} from '@app/modules/core/utils/social-login.config';
import { GoogleTagManagerService } from '@core/services/analytics/google-tag-manager.service';
import {
  AuthAgency,
  AuthUser,
  RequestResponse,
  VehicleData,
} from '@shared/models';

import { RecoveryPassDialogComponent } from '../recovery-pass-dialog/recovery-pass-dialog.component';

const STATE_SNAPSHOT = 'state_snapshot';
const STATE_TIMESTAMP = 'state_timestamp';

@UntilDestroy()
@Component({
  selector: 'bkg-login-dialog',
  templateUrl: './login-dialog.component.html',
})
export class LoginDialogComponent implements OnInit {
  @Select(VehicleState.vehicle) vehicleData$: Observable<Vehicle>;

  form: FormGroup;
  errorMessage: string;
  modifyToken: string;
  showContinue: boolean;

  isIndividualCustomer = true;
  isAgency = false;
  userData: User;
  agencyData: Agency;

  constructor(
    public ref: DialogRef,
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private socialAuthService: SocialAuthService,
    private store: Store,
    private dialog: DialogService,
    private authenticatedApi: AuthenticatedApiService,
    private router: Router,
    private userService: UserService,
    private googleTagManagerService: GoogleTagManagerService,
    private activeCampaignService: ActiveCampaignService
  ) { }

  get isInvalidForm(): boolean {
    return this.form?.invalid;
  }

  ngOnInit(): void {
    this.modifyToken = this.ref.data?.modifyToken as string;
    this.showContinue = this.ref.data?.showContinue as boolean;
    this.initForm();
  }

  onContinue(): void {
    this.googleTagManagerService.pushOnDataLayer({
      event: 'booking-user-no-login',
    });
    this.googleTagManagerService.pushBookingActionOnDataLayer({
      event_name: 'booking-user-no-login',
    });
    this.ref.close();
  }

  onClickFacebookLogin(): void {
    this.socialAuthService
      .signIn(FacebookLoginProvider.PROVIDER_ID)
      .then((socialUser: SocialUser) => {
        this.socialLogin(
          SOCIAL_TOKENS.facebook,
          socialUser.authToken,
          socialUser.provider.toLocaleLowerCase()
        );
      });
  }

  onClickGoogleLogin(): void {
    this.socialAuthService
      .signIn(GoogleLoginProvider.PROVIDER_ID)
      .then((socialUser: SocialUser) =>
        this.socialLogin(
          SOCIAL_TOKENS.google,
          socialUser.idToken,
          socialUser.provider.toLocaleLowerCase()
        )
      ).catch(err => {
        console.log(err)
        if (err && err.error === 'popup_closed_by_user') {
          console.warn('El usuario cerró el popup sin loguearse');
        } else {
          console.error('Error en el login:', err);
        }
      });
  }

  onClickAppleLogin(): void {
    const provider = new firebase.auth.OAuthProvider('apple.com');
    firebase
      .auth()
      .signInWithPopup(provider)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((result: any) => {
        this.socialLogin(
          SOCIAL_TOKENS.apple,
          result.credential.idToken,
          PROVIDERS.apple
        );
      });
  }

  onClickLoginBtn(): void {
    const { email, password } = this.form.value as AuthUser;

    from(this.authService.login(email, btoa(password)))
      .pipe(untilDestroyed(this))
      .subscribe(
        () => this.onSuccessLogin(),
        (err: HttpErrorResponse) => this.onLoginError(err?.error)
      );
  }

  onClickAgencyLoginBtn(): void {
    const { alias, password } = this.form.value as AuthAgency;

    from(this.authService.loginAgency(alias, btoa(password)))
      .pipe(untilDestroyed(this))
      .subscribe(
        () => this.onSuccessLogin(),
        (err: HttpErrorResponse) => this.onLoginError(err?.error)
      );
  }

  onCloseBanner(): void {
    this.errorMessage = null;
  }

  navigateToSignUp(): void {
    this.ref.close(true);
  }

  navigateToForgetYourPass(): void {
    this.dialog.open(RecoveryPassDialogComponent, {
      closeButton: false,
      size: 'sm',
      backdrop: true,
    });
    this.ref.close(false);
  }

  hasErrors(fieldName: string): boolean {
    const control = this.form.get(fieldName);

    return !!control?.invalid && !!control.touched;
  }

  isValidField(fieldName: string): boolean {
    const control = this.form.get(fieldName);

    return !!control?.valid;
  }

  private onSuccessLogin(tokenName?: string): void {
    if (this.authService.isTokenValid()) {
      if (this.isIndividualCustomer) {
        if (tokenName && tokenName === SOCIAL_TOKENS.google) {
          this.googleTagManagerService.pushOnDataLayer({
            event: 'booking-user-login-gmail',
          });
          this.googleTagManagerService.pushBookingActionOnDataLayer({
            event_name: 'booking-user-login-gmail',
          });
        } else if (tokenName && tokenName === SOCIAL_TOKENS.facebook) {
          this.googleTagManagerService.pushOnDataLayer({
            event: 'booking-user-login-facebook',
          });
          this.googleTagManagerService.pushBookingActionOnDataLayer({
            event_name: 'booking-user-login-facebook',
          });
        } else {
          this.googleTagManagerService.pushOnDataLayer({
            event: 'booking-user-login-email',
          });
          this.googleTagManagerService.pushBookingActionOnDataLayer({
            event_name: 'booking-user-login-email',
          });
        }
        this.userService
          .getUser()
          .pipe(untilDestroyed(this))
          .subscribe((user: User) => {
            localStorage.removeItem(STATE_SNAPSHOT);
            localStorage.removeItem(STATE_TIMESTAMP);
            this.store.dispatch(new SetUserAction(user));
            this.checkVehicle(user);

            this.userService.sendUtm(user);
          });
      } else {
        this.googleTagManagerService.pushOnDataLayer({
          event: 'web-agency-login',
        });
        this.googleTagManagerService.pushBookingActionOnDataLayer({
          event_name: 'web-agency-login',
        });
        this.userService
          .getAgency()
          .pipe(untilDestroyed(this))
          .subscribe((agency: Agency) => {
            localStorage.removeItem(STATE_SNAPSHOT);
            localStorage.removeItem(STATE_TIMESTAMP);
            this.store.dispatch(new SetAgencyAction(agency));
            this.ref.close();
          });
      }

      this.activeCampaignService.setACEmail(this.form.value.email);
    } else {
      this.errorMessage = 'Invalid token';
    }
  }

  private checkVehicle(user: User): void {
    this.vehicleData$
      .pipe(first(), untilDestroyed(this))
      .subscribe((vehicleData: Vehicle) => {
        if (vehicleData?.id) {
          this.addGuestVehicleToUser(vehicleData.id, user);
        } else {
          this.ref.close();
        }
      });
  }

  private addGuestVehicleToUser(vehicleId: number, user: User): void {
    this.store.dispatch(new StartLoadingAction());
    this.authenticatedApi
      .put('vehicle/register_guest_vehicle/' + vehicleId.toString())
      .pipe(untilDestroyed(this))
      .subscribe(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (data: any) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          const vehicle = data.vehicle as Vehicle;
          this.onSuccessGuestVehicleAdded(vehicle, user);
        },
        () => {
          this.store.dispatch([
            new RemoveVehicleAction(),
            new StopLoadingAction(),
          ]);
          this.router.navigate(['/services']);
        }
      );
  }

  private onSuccessGuestVehicleAdded(vehicle: Vehicle, user: User): void {
    const {
      id,
      vehicle_information,
      km,
      km_timestamp: kmTimestamp,
      workshop_type,
    } = vehicle;
    const vehicleData = {} as VehicleData;
    vehicleData.id = id;
    vehicleData.km = km;
    vehicleData.kmTimestamp = kmTimestamp;
    vehicleData.motorCode =
      vehicle_information?.motor_applicabilitycode ?? null;
    vehicleData.bodyCode = vehicle_information?.body_description ?? null;
    vehicleData.bodyDesc = vehicle_information?.body_description ?? null;
    vehicleData.umc = vehicle_information?.umc ?? null;
    vehicleData.umcData = vehicle_information?.umc_data ?? null;
    vehicleData.workshopType = +workshop_type;
    vehicleData.makeCode = vehicle_information?.make_code ?? null;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const updatedUser = JSON.parse(JSON.stringify(user));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    updatedUser.vehicles.push(vehicle);
    this.store.dispatch([
      new SetUserAction(updatedUser),
      new SetVehicleAction(vehicle, vehicleData),
      new StopLoadingAction(),
    ]);
    this.ref.close();
  }

  private onLoginError(error: RequestResponse): void {
    this.errorMessage = error.reason;
  }

  private initForm(): void {
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, Validators.required],
    });
  }

  private socialLogin(
    tokenName: string,
    token: string,
    provider: string
  ): void {
    from(this.authService.loginSSO(tokenName, token, provider))
      .pipe(untilDestroyed(this))
      .subscribe(
        () => this.onSuccessLogin(tokenName),
        (error: HttpErrorResponse) => {
          this.socialAuthService.signOut();
          this.onLoginError(error?.error);
        }
      );
  }

  selectTab(value: number): void {
    this.form.controls.password.setValue(null);

    if (value === 1) {
      this.isIndividualCustomer = true;
      this.isAgency = !this.isIndividualCustomer;
      this.form.addControl(
        'email',
        new FormControl(null, [Validators.required, Validators.email])
      );
      this.form.removeControl('alias');
    } else {
      this.isIndividualCustomer = false;
      this.isAgency = !this.isIndividualCustomer;
      this.form.addControl('alias', new FormControl(null, Validators.required));
      this.form.removeControl('email');
    }
  }

  get individualCustomerBtnClass(): string {
    return this.isIndividualCustomer
      ? 'modal__tab modal__tab-selected'
      : 'modal__tab';
  }

  get agencyBtnClass(): string {
    return this.isAgency ? 'modal__tab modal__tab-selected' : 'modal__tab';
  }

  get isIos(): boolean {
    const is_OSX = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    const is_iOS = /(iPhone|iPod|iPad)/i.test(navigator.platform);

    const is_Mac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    const is_iPhone = navigator.platform === 'iPhone';
    const is_iPod = navigator.platform === 'iPod';
    const is_iPad = navigator.platform === 'iPad';

    return is_OSX || is_iOS || is_Mac || is_iPhone || is_iPod || is_iPad;
  }
}
